import { Col } from '@design-system/components/grid/grid';
import { forwardRef } from 'react';

import { TabataExerciseSetDTO } from '../../../model/workout.domain';
import { TabataExerciseVM } from '../../../view-model/workouts.domain';
import { TimeInput } from '@design-system/components/time-input';
import { Typography } from '@design-system/components/typography/typography';
import { RepsInput } from '../RepInput';
import { defaults } from '../../../view-model/workout.schema';

type RendererProps = {
  data: TabataExerciseSetDTO;
  index: number;
  register: TabataExerciseVM['register'];
};

export const SetRenderer = forwardRef<HTMLDivElement, RendererProps>(
  (props, ref) => {
    const { data, index, register } = props;
    return (
      <>
        <Col center ref={ref}>
          <Typography variant="body" size="large" color="N-80">
            {index + 1}
          </Typography>
        </Col>
        <TimeInput
          {...register(`sets.${index}.time`, { noValue: true } as any)}
          value={data.time}
          min={defaults.time.min}
          max={defaults.time.max}
        />
        <RepsInput
          {...register(`sets.${index}.rep`, { noValue: true } as any)}
          value={data.rep}
        />
        <TimeInput
          {...register(`sets.${index}.rest`, { noValue: true } as any)}
          value={data.rest}
          min={defaults.rest.min}
          max={defaults.rest.max}
        />
      </>
    );
  },
);

SetRenderer.displayName = 'SetRenderer';
